<div class="settings-page" *ngIf="client">
  <div class="content-center" [class.overlay-open]="showNewInline">
    <div
      *ngIf="isLoadingEmailFooters"
      class="loading-wrapper"
      aria-hidden="true"
    >
      <div class="loading-state">
        <div class="spinner" aria-hidden="true"></div>
        <p>Loading email...</p>
      </div>
    </div>

    <ng-container *ngIf="!isLoadingEmailFooters">
      <div class="tabs-row">
        <div class="tabs" role="tablist" aria-label="Email settings tabs">
          <button
            class="tab"
            [class.active]="!showFooterView"
            (click)="setView(false)"
          >
            Email Settings
          </button>
          <button
            class="tab"
            [class.active]="showFooterView"
            (click)="setView(true)"
          >
            Email Footers
          </button>

          <a
            class="add-new"
            *ngIf="showFooterView && canManageEmailFooters"
            (click)="openNewInline()"
            >Add New Email Footer</a
          >
        </div>

        <p class="instruction" *ngIf="showFooterView">
          For use of creating footers for each departmental function used across
          multiple email notification types within one or more workflows. Making
          edits to the footer here will automatically update it in all locations
          it is currently used (click on USAGE).
        </p>
      </div>

      <div
        class="new-footer-inline"
        *ngIf="showNewInline"
        role="dialog"
        aria-modal="true"
        [attr.aria-label]="
          isEditMode ? 'Edit Email Footer' : 'Add Email Footer'
        "
      >
        <div class="new-footer-header">
          <div class="title">
            {{ isEditMode ? 'Edit Email Footer' : 'Add Email Footer' }}
          </div>
          <button
            class="modal-close"
            (click)="closeNewInline()"
            aria-label="Close"
          >
            ✕
          </button>
        </div>

        <form class="modal-form" [formGroup]="form" (ngSubmit)="saveInline()">
          <div class="row">
            <div class="col">
              <label class="field-label">Email Footer Label</label>
              <input
                class="input"
                formControlName="label"
                placeholder="Label"
              />
              <div
                class="error-message text-danger small"
                *ngIf="form.get('label')?.invalid && form.get('label')?.touched"
              >
                Label is required
              </div>
            </div>

            <div class="col">
              <label class="field-label">Enabled</label>
              <label class="toggle-item">
                <input
                  type="checkbox"
                  class="native-toggle"
                  formControlName="enabled"
                />
              </label>
            </div>
          </div>

          <div class="row single">
            <div class="col">
              <label class="field-label">Content</label>
              <!-- Wrapper added to enable horizontal scrolling for CKEditor on mobile -->
              <div class="editor-scroll-wrapper">
                <ckeditor
                  #htmlEditor
                  [editor]="Editor"
                  [config]="editorConfig"
                  formControlName="content"
                  (ready)="editorReady($event)"
                ></ckeditor>
              </div>

              <div
                class="error-message text-danger small"
                *ngIf="
                  form.get('content')?.invalid && form.get('content')?.touched
                "
              >
                Content is required
              </div>
            </div>
          </div>

          <div class="form-actions modal-actions">
            <button type="button" class="btn cancel" (click)="closeNewInline()">
              CANCEL
            </button>
            <button
              type="submit"
              class="btn save"
              [disabled]="!form.valid || isSaving"
            >
              <span *ngIf="isSaving">SAVING...</span>
              <span *ngIf="!isSaving">SAVE</span>
            </button>
          </div>
        </form>
      </div>

      <section *ngIf="showFooterView" class="card card--large">
        <div class="table-responsive">
          <div class="table-head" role="row">
            <div class="th">Label</div>
            <div class="th">Enabled</div>
            <div class="th">Disable</div>
            <div class="th">View Usage</div>
            <div class="th">Edit</div>
          </div>

          <div class="table-body-wrapper">
            <app-loader *ngIf="!emailFooters && client"></app-loader>
            <div class="table-body" *ngIf="emailFooters">
              <div
                class="p-3 text-center text-muted"
                *ngIf="emailFooters.length === 0"
              >
                <i>No Email Footers to display</i>
              </div>

              <div class="table-row" *ngFor="let ef of emailFooters" role="row">
                <div class="td">{{ ef.label }}</div>
                <div class="td">{{ ef.isEnabled ? 'Yes' : 'No' }}</div>

                <div class="td">
                  <a
                    class="action-link"
                    [class.text-blue]="ef.isEnabled"
                    [class.text-grey]="!ef.isEnabled"
                    (click)="toggleEnabled(ef)"
                  >
                    {{ ef.isEnabled ? 'Disable' : 'Enable' }}
                  </a>
                </div>

                <div class="td">
                  <a
                    class="action-link text-blue"
                    *ngIf="ef.inUse"
                    (click)="viewUsage(ef.id)"
                    >View</a
                  >
                  <span class="action-text text-grey" *ngIf="!ef.inUse"
                    >Inactive</span
                  >
                </div>

                <div class="td">
                  <a class="action-link text-blue" (click)="openEditInline(ef)"
                    >Edit</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section *ngIf="!showFooterView">
        <p class="note">
          <strong>IMPORTANT NOTE:</strong> In order for this to get setup,
          someone will need to be able to modify the DNS records for the domain
          that they want to use.
        </p>

        <div class="card card--domain">
          <label class="label">Custom from Domain</label>
          <input
            class="input"
            placeholder="Domain"
            [(ngModel)]="client.customFromDomain"
          />

          <div class="domain-actions">
            <button
              class="btn neutral"
              *ngIf="!isCustomFromTestingEnabled"
              [disabled]="!client.customFromDomain"
              (click)="enableDomainForTesting()"
            >
              ENABLE DOMAIN FOR TESTING
            </button>
            <button
              class="btn neutral"
              *ngIf="isCustomFromTestingEnabled"
              [disabled]="!client.customFromDomain"
              (click)="disableDomainForTesting()"
            >
              DISABLE DOMAIN FOR TESTING
            </button>

            <button
              class="btn neutral"
              [disabled]="!client.customFromDomain"
              (click)="validateEmail()"
            >
              VALIDATE EMAIL
            </button>

            <button class="btn primary" (click)="onSaveDomainClick()">
              SAVE
            </button>
          </div>

          <div
            class="mt-3"
            *ngIf="customFromDomainResult?.messages?.length > 0"
          >
            <div
              [ngClass]="{
                'text-danger': !customFromDomainResult.valid,
                'text-success': customFromDomainResult.valid
              }"
            >
              Validation Messages
            </div>
            <ul class="list-group mt-2">
              <li
                class="list-group-item"
                [ngClass]="{
                  'list-group-item-danger': !customFromDomainResult.valid,
                  'list-group-item-success': customFromDomainResult.valid
                }"
                *ngFor="let m of customFromDomainResult.messages"
              >
                {{ m }}
              </li>
            </ul>
          </div>
        </div>
      </section>
    </ng-container>
  </div>

  <div class="custom-modal-overlay" *ngIf="showUsageModal">
    <div class="custom-modal-content">
      <div class="custom-modal-header">
        <h3 class="title">Email Footer Usage</h3>
        <button class="close-btn" (click)="closeUsageModal()">×</button>
      </div>

      <div class="custom-modal-body">
        <app-loader *ngIf="loadingWorkflowActivities"></app-loader>

        <ng-container *ngIf="!loadingWorkflowActivities">
          <div *ngIf="workflowActivities.length === 0" class="text-center p-4">
            No active workflows currently use this footer.
          </div>
          <table
            class="table mt-3 text-left"
            *ngIf="workflowActivities.length > 0"
          >
            <thead>
              <tr>
                <th>Workflow</th>
                <th>Activity</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let a of workflowActivities">
                <td>{{ a.workflowName }}</td>
                <td>{{ a.activityName }}</td>
                <td class="text-right">
                  <a
                    target="_blank"
                    [routerLink]="['/admin/workflow-builder/', a.workflowId]"
                    [queryParams]="{ activityId: a.activityId }"
                  >
                    Workflow Builder
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </ng-container>
      </div>

      <div class="custom-modal-footer">
        <button class="btn neutral" (click)="closeUsageModal()">Close</button>
      </div>
    </div>
  </div>
</div>
